import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import eventModel from "src/models/plan/models/event"
import moment from "moment"
import collection from "src/hocs/collection"

const configurator = ({ data, planId }) => ({
  engine: entity,
  to: `events`,
  model: eventModel(planId),
  query: {
    query: `startDateTime<${moment(data.originalEndTime)
      .startOf(`minute`)
      .valueOf()};endDateTime>${moment(data.originalStartTime)
      .startOf(`minute`)
      .valueOf()};resourceUuids==${data.resourceUuid}`,
    orderBy: `startDateTime DESC`,
    limit: -1,
  },
})

export default config =>
  compose(
    /* Using props' flow allows to extend basic configuration */
    collection(props => ({
      ...configurator(props),
      ...(isFunction(config) ? config(props) : config),
    })),
  )
